import { useParams } from 'react-router-dom';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import useFetchEventOverviewStats, { EStatKeys } from '../helpers/use-fetch-event-overview-stats';
import { getPublishedStatus } from '@/store/slices/project/selectors';
import { useAppSelector } from '@/store/hooks';
import { EProjectStatus } from '@/types/projects.types';
import StatsCard from '../components/stats-card';
import { useIsLoadingStat } from '../helpers/use-is-loading-stat';
import useGetStatsIconColors from '../helpers/use-get-stats-icon-colors';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import IconFilterAltGradient from '@ui/icons/gradient-icons/icon-filter-alt-gradient';

const TownhallStats = () => {
  const params = useParams();
  const language = params?.language || 'en';
  const projectUuid = params?.projectUuid || '';

  const { data } = useFetchEventOverviewStats({
    projectUuid,
    language,
    stats: [
      EStatKeys.invites,
      EStatKeys.registrations,
      EStatKeys.uniqueAttendees,
      EStatKeys.avgUserWatchtime,
      EStatKeys.averageProjectRating,
      EStatKeys.interactions,
    ],
  });

  const publishedStatus = useAppSelector(getPublishedStatus);

  const isPublished = publishedStatus?.status === EProjectStatus.PUBLIC;

  const isLoadingStat = useIsLoadingStat(data, isPublished);

  const statsColors = useGetStatsIconColors();

  return (
    <Container data-component="TownhallStats" className="padding-t-8" maxWidth="392px">
      <Container className="margin-b-8">
        <Text tag="h5" className="H5" design="GlobalIcoText1">
          Stats
        </Text>
      </Container>
      <Container className="flex fd-row fw-wrap jc-flex-start ai-center gap-8">
        <StatsCard
          loading={isLoadingStat(EStatKeys.invites)}
          title="Invited"
          tooltip="Unique users who have registered for this event."
          value={isPublished ? (data[EStatKeys.invites]?.value ?? -1) : -1}
          subvalue={data[EStatKeys.registrations]?.subValue}
          Icon={<Icon name={ICONS.RESEND_EMAIL} color={statsColors.from} size={16} />}
        />
        <StatsCard
          loading={isLoadingStat(EStatKeys.registrations)}
          title="Registered"
          tooltip="Unique users who have registered for this event."
          value={isPublished ? (data[EStatKeys.registrations]?.value ?? -1) : -1}
          subvalue={data[EStatKeys.registrations]?.subValue}
          Icon={<Icon name={ICONS.REGISTERED} color={statsColors.from} size={16} />}
        />
        <StatsCard
          loading={isLoadingStat(EStatKeys.interactions)}
          title="Interactions"
          tooltip="Page views."
          value={isPublished ? (data[EStatKeys.interactions]?.value ?? -1) : -1}
          Icon={<IconFilterAltGradient from={statsColors.from} to={statsColors.to} />}
        />
      </Container>
    </Container>
  );
};

export default TownhallStats;
